var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtm1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36067 9.09362L5.728 6.25107C5.29933 5.91509 4.70133 5.91509 4.27133 6.25107L0.64 9.09362C0.233333 9.41161 0 9.88959 0 10.4062V16H10V10.4056C10 9.88959 9.76667 9.41161 9.36067 9.09362ZM9.33333 15.3327H0.666667V10.4056C0.666667 10.0956 0.806667 9.80826 1.05067 9.6176L4.682 6.77505C4.86933 6.62906 5.13067 6.62906 5.31667 6.77505L8.94933 9.6176C9.19267 9.80826 9.33267 10.0956 9.33267 10.4056L9.33333 15.3327ZM3.33333 13.3328H6.66667V9.99958H3.33333V13.3328ZM4 10.6662H6V12.6661H4V10.6662ZM12 8.66631H13.3333V9.33294H12V8.66631ZM12 11.3329H13.3333V11.9995H12V11.3329ZM9.33333 3.33319H10.6667V3.99983H9.33333V3.33319ZM13.3333 3.99983H12V3.33319H13.3333V3.99983ZM9.33333 5.99975H10.6667V6.66639H9.33333V5.99975ZM12 5.99975H13.3333V6.66639H12V5.99975ZM16 1.6666V15.9993H11.3333V15.3327H15.3333V1.6666C15.3333 1.11529 14.8847 0.666639 14.3333 0.666639H8.33333C7.782 0.666639 7.33333 1.11529 7.33333 1.6666V5.99975L6.66667 5.47777V1.6666C6.66667 0.747302 7.414 0 8.33333 0H14.3333C15.2527 0 16 0.747302 16 1.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtm1);
export default __webpack_public_path__ + "static/media/btm1.7ceae2ae12429935215e1894d2be439e.svg";
export { ForwardRef as ReactComponent };